var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIconWhiteV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5825 0.396566L4.5525 3.39657C-1.5175 5.42657 -1.5175 8.73657 4.5525 10.7566L7.2325 11.6466L8.1225 14.3266C10.1425 20.3966 13.4625 20.3966 15.4825 14.3266L18.4925 5.30657C19.8325 1.25657 17.6325 -0.953434 13.5825 0.396566ZM13.9025 5.77657L10.1025 9.59657C9.9525 9.74657 9.7625 9.81657 9.5725 9.81657C9.3825 9.81657 9.1925 9.74657 9.0425 9.59657C8.7525 9.30657 8.7525 8.82657 9.0425 8.53657L12.8425 4.71657C13.1325 4.42657 13.6125 4.42657 13.9025 4.71657C14.1925 5.00657 14.1925 5.48657 13.9025 5.77657Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconWhiteV2);
export default __webpack_public_path__ + "static/media/send-icon-white-v2.c4b8a7d3a984abd5976c1cf99a9d2739.svg";
export { ForwardRef as ReactComponent };